import { render, staticRenderFns } from "./ArrowExt.vue?vue&type=template&id=81d8000e&"
import script from "./ArrowExt.vue?vue&type=script&lang=js&"
export * from "./ArrowExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports